export const analysis = {
    status: 'finished',
    score: {
        s: {
            cpu: 0.41500000000000004,
            screen: 12.7975,
            totalTime: 45.93849999999999,
        },
        gb: {
            mem: 0.7338639360000001,
            disk: 0,
            network: 0.0036178884999999994,
        },
        wh: {
            cpu: 0.012,
            mem: 0,
            disk: 0,
            total: 0.078,
            screen: 0.036,
            network: 0.03,
        },
        co2: {
            total: 0.034,
        },
    },
    createdAt: '2022-02-23T13:51:46.497Z',
    gitCommitMessage: 'Paginate results by 50 instead of 10',
    gitBranchName: 'acme-analysis',
    gitCommitId: '92616c5513eb4410dacbd4ae6afa9498781a0a61',
    gitDefaultBranchCommitReference: '4fb16c4a37d259c9489d8b2b8f42e204348781f7',
    finishedAt: '2022-02-23T13:52:30.644Z',
    samples: 3,
    incrementalId: 3,
    pageTitle: null,
    pageScreenshot: null,
    project: {
        name: 'Demo',
    },
};
